import { isModulrAccount } from '@/utils/accounts/is-modulr-account';
import { FinancialServiceProviderAdapters } from '@seapoint/server/enums';
import { AccountBankingTypeView, AccountView } from '../../../types/entity-types';

/**
 * Checks if an account can initiate internal payments based on its FSP adapter.
 * Only accounts with Modulr, Yapily and Wealthkernel adapters can initiate internal payments.
 *
 * @param account - The account to check for payment initiation capability
 * @returns true if the account can initiate payments (has Modulr, Yapily or Wealthkernel adapter), false otherwise
 */
export const canInitiateInternalPayments = (account: AccountView) => {
  return (
    isModulrAccount(account) ||
    account.fspAdapter === FinancialServiceProviderAdapters.YAPILY ||
    account.fspAdapter === FinancialServiceProviderAdapters.WEALTHKERNEL
  );
};

/**
 * Checks if an account can initiate external payments based on its FSP adapter.
 * Only accounts with Modulr or Yapily adapters can initiate payments.
 *
 * @param account - The account to check for payment initiation capability
 * @returns true if the account can initiate payments (has Modulr or Yapily adapter), false otherwise
 */
export const canInitiateExternalPayments = (account: AccountView) => {
  return isModulrAccount(account) || account.fspAdapter === FinancialServiceProviderAdapters.YAPILY;
};

/**
 * Checks if an account can initiate bulk payments based on its FSP adapter.
 * Only accounts with Modulr adapter can initiate bulk payments.
 *
 * @param account - The account to check for bulk payment initiation capability
 * @returns true if the account can initiate bulk payments (has Modulr adapter), false otherwise
 */
export const canInitiateBulkPayments = (account: AccountBankingTypeView) => {
  return isModulrAccount(account);
};
